import { EntityLayout } from "@backstage/plugin-catalog";
import {
  EntityUserProfileCard,
  EntityOwnershipCard,
} from "@backstage/plugin-org";
import { Grid } from "@material-ui/core";
import { EntityCloudAssignmentsContent } from "@prisamedia/plugin-cloudhealth-explorer";

import entityWarningContent from "../common/entityWarningContent";

export default (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}>
          <EntityUserProfileCard variant="gridItem" />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityOwnershipCard variant="gridItem" />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/cloud-assets" title="Cloud Assets">
      <EntityCloudAssignmentsContent />
    </EntityLayout.Route>
  </EntityLayout>
);
